import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import routes from "./Routes/Routes"

function App() {
  return <div className="container mx-auto px-4 lg:px-0">
    <RouterProvider router={routes} />
    <Toaster
  position="bottom-center"
  reverseOrder={false}
/>
  </div>;
}

export default App;
